import { jsx as _jsx } from "react/jsx-runtime";
import { AnalysisColumnsTypes } from 'nmr-load-save';
import { memo } from 'react';
import { useChartData } from '../../context/ChartContext';
import { usePanelPreferences } from '../../hooks/usePanelPreferences';
import AnalysisRange from './AnalysisRange';
function MultiAnalysisRangesInner({ columns, displayerKey, activeTab, }) {
    const ranges = Object.keys(columns).filter((key) => columns[key].type !== AnalysisColumnsTypes.FORMULA);
    if (!ranges || ranges.length === 0) {
        return null;
    }
    return (_jsx("g", { clipPath: `url(#${displayerKey}clip-chart-1d)`, children: ranges.map((columnKey) => (_jsx(AnalysisRange, { columnKey: columnKey, rangeData: columns[columnKey], activeTab: activeTab }, columnKey))) }));
}
const MemoizedMultiAnalysisRanges = memo(MultiAnalysisRangesInner);
export default function MultiAnalysisRanges() {
    const { view: { spectra: { activeTab }, }, displayerKey, } = useChartData();
    const multipleSpectraAnalysis = usePanelPreferences('multipleSpectraAnalysis', activeTab);
    const columns = multipleSpectraAnalysis.analysisOptions.columns;
    return (_jsx(MemoizedMultiAnalysisRanges, { columns, displayerKey, activeTab }));
}
